<template>
  <div class="blur-wrapper" :class="blurClasses">
    <div class="blur">
      <slot />
    </div>
    <div v-if="blur" class="blur-overlay">
      <slot v-if="blur" name="overlay" />
    </div>
  </div>
</template>

<script>
/**
 * Display content of a slot into an blur-overlay-able component
 */


export default {
  name: 'BlurWrapper',

  props: {
    blur: Boolean,
  },

  computed: {
    blurClasses() {
      return {
        blurred: this.blur,
      };
    },
  },
};
</script>

<style lang="scss">
.blur-wrapper {
  position: relative;

  &.blurred {

    .blur {
      filter: blur(1.8px);
    }
    .blur-overlay {
      position: absolute;
      top: 0px;
      bottom: 0px;
      left: 0px;
      right: 0px;
    }
  }
}
</style>
